<header class="site-header">
  <a class="logo" routerLink="/">Friendlai</a>
  <app-site-menu />
</header>
<router-outlet />
<app-consent-banner />
<app-update-banner />
